function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
var API_TIMEOUT_MS = 2000;
export var VizioNativeWrapper = /*#__PURE__*/ function() {
    "use strict";
    function VizioNativeWrapper() {
        _class_call_check(this, VizioNativeWrapper);
    }
    _create_class(VizioNativeWrapper, null, [
        {
            key: "getDevicePlaybackQualities",
            value: function getDevicePlaybackQualities() {
                return new Promise(function(resolve, reject) {
                    var timeout = setTimeout(function() {
                        return reject(new Error('Vizio API Timeout'));
                    }, API_TIMEOUT_MS);
                    VIZIO.getDevicePlaybackQualities(function(qualities) {
                        clearTimeout(timeout);
                        resolve(qualities);
                    });
                });
            }
        },
        {
            key: "getDeviceHDRCapabilities",
            value: function getDeviceHDRCapabilities() {
                return new Promise(function(resolve, reject) {
                    if (!VIZIO.getDeviceHDRCapabilities) {
                        reject(new Error('`getDeviceHDRCapabilities` method not available on window'));
                    } else {
                        var timeout = setTimeout(function() {
                            return reject(new Error('Vizio API Timeout'));
                        }, API_TIMEOUT_MS);
                        VIZIO.getDeviceHDRCapabilities(function(capabilities) {
                            clearTimeout(timeout);
                            resolve(capabilities);
                        });
                    }
                });
            }
        }
    ]);
    return VizioNativeWrapper;
}();

//# sourceMappingURL=vizio-native-wrapper.js.map